import { Dimensions, StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingLeft: 20,
    paddingRight: 20,
    justifyContent: "flex-start",
    backgroundColor: "#fff",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 10,
  },
  footer: {
    width: "100%",
    padding: 15,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  view: {
    marginVertical: 25,
    borderWidth: 1,
    borderRadius: 4,
    alignItems: "center",
    justifyContent: "center",
    borderColor: "#666",
    width: "100%",
    overflow: "hidden",
  },
  nameCategory: {
    position: "absolute",
    marginTop: 110,
    textAlign: "center",
    color: "#fff",
    fontWeight: "bold",
    width: "100%",
  },
  contentDescription: {
    padding: 15,
    marginTop: 20,
  },
  description: {
    textAlign: "justify",
    fontSize: 12,
    fontWeight: "400",
    lineHeight: 16,
  },
  contentBtn: {
    flex: 1,
    paddingHorizontal: 25,
    marginTop: 25,
  },
  btn: {
    padding: 10,
    width: "100%",
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    position: "relative",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
  label: {
    marginTop: 12,
    fontSize: 20,
    textAlign: "center",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  label2: {
    fontSize: 14,
    marginTop: 15,
    marginBottom: 15,
    marginLeft: 15,
    marginRight: 15,
    textAlign: "center",
  },
  label3: {
    fontSize: 14,
    marginBottom: 15,
    marginLeft: 15,
    marginRight: 15,
    textAlign: "center",
  },
  label1: {
    fontSize: 14,
    marginBottom: 15,
    marginLeft: 15,
    marginRight: 15,
    textAlign: "left",
  },
  input: {
    width: "90%",
    borderBottomWidth: 0.5,
  },
  hr: {
    borderBottomWidth: 1,
    width: "60%",
    marginVertical: 15,
  },
  signature: {
    flexWrap: "wrap",
    alignSelf: "center",
    flexDirection: "row",
    marginBottom: 20,
    alignItems: "center",
    justifyContent: "center",
    width: "50%",
    height: "auto",
  },
  signatureLine: {
    borderTopWidth: 1,
    width: "100%",
    marginBottom: 12,
  },
  iconsFooter: {
    width: 190,
    height: 60,
    resizeMode: "contain",
  },
  backgroundImage: {
    position: "absolute",
    top: 20,
    left: 0,
    width: "100%",
    alignItems: "center",
    zIndex: 0,
  },
  image2: {
    width: "40%",
    height: 60,
    marginTop: 10,
    marginLeft: "auto",
    marginRight: "auto",
    resizeMode: "contain",
  },
  image3: {
    width: 160,
    height: 22,
    marginTop: 20,
    marginBottom: 20,
    marginLeft: "auto",
    marginRight: "auto",
  },
  green: {
    color: "#96B533",
  },
  signatureImg: {
    minHeight: 84,
    minWidth: 84,
    alignSelf: "center",
    resizeMode: "contain",
  },
  bandeirasBtnContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 12,
    alignItems: "center",
    alignSelf: "center",
  },
  iconBandeira: {
    fontSize: 45,
  },

  imgBackground: {
    maxWidth: "50%",
    maxHeight: 45,
    width: "50%",
    height: Dimensions.get("screen").height * 0.8,
    position: "absolute",
    top: "50%",
    bottom: "50%",
    zIndex: "-9999",
    alignSelf: "center",
    justifySelf: "center",
    resizeMode: "contain",
  },

  viewAbrirBandeiras: {
    paddingVertical: 15,
    flexDirection: "column",
    justifyContent: "space-between",
    alignContent: "center",
  },

  image: {
    width: 60,
    height: 60,
    marginBottom: 3,
  },

  qrCodeText: {
    marginTop: 12,
    flexWrap: "wrap",
  },

  qrCodeContainer: {
    flexDirection: "column",
    alignItems: "center",
  },

  flagIcon: {
    width: 32,
    height: 24,
  },
});

export default styles;
